import { h } from '@stencil/core';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/lib/types/sydle-app.ts
var require_sydle_app = __commonJS({
  "src/lib/types/sydle-app.ts"() {
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Consumer: () => Consumer,
  Debounce: () => Debounce,
  Provider: () => Provider,
  Throttle: () => Throttle,
  deleteURLParam: () => deleteURLParam,
  getAbsoluteUrl: () => getAbsoluteUrl,
  getAction: () => getAction,
  getConfig: () => getConfig,
  getHTMLTitle: () => getHTMLTitle,
  getRelativeURL: () => getRelativeURL,
  getRouteById: () => getRouteById,
  getRouteByIdentifier: () => getRouteByIdentifier,
  getRouter: () => getRouter,
  getURLParam: () => getURLParam,
  navigate: () => navigate,
  navigateToPath: () => navigateToPath,
  reloadPageContent: () => reloadPageContent,
  renderComponent: () => renderComponent,
  setAction: () => setAction,
  setActionAll: () => setActionAll,
  setHTMLTitle: () => setHTMLTitle,
  setURLParam: () => setURLParam,
  urlFor: () => urlFor
});

// src/lib/context-utils.ts
var Provider = class {
  /**
   * Creates an instance of Provider.
   * @param element - The element that acts as a context provider for child elements.
   */
  constructor(element) {
    this.element = element;
    if (!this.element.__provides) {
      this.element.__provides = /* @__PURE__ */ new Map();
    }
    this.element.setAttribute("data-sy-provider", "");
    this.element.getCurrentValueOf = (contextKey) => {
      if (!this.element.__provides)
        return;
      const provider = this.element.__provides.get(contextKey);
      if (!provider)
        return;
      return provider.currentValue;
    };
    this.element.isProviderOf = (contextKey) => {
      return !!this.element.__provides?.get(contextKey);
    };
    this.element.subscribe = (contextKey, callback) => {
      if (!this.element.__provides)
        return;
      const provider = this.element.__provides.get(contextKey);
      if (!provider)
        return;
      provider.callbacks.add(callback);
      return callback(provider.currentValue);
    };
    this.element.unsubscribe = (contextKey, callback) => {
      if (!this.element.__provides)
        return;
      const provider = this.element.__provides.get(contextKey);
      if (!provider)
        return;
      provider.callbacks.delete(callback);
    };
  }
  /**
   * Creates a new context in the provider element for the child elements. It is
   * recommended to use this method in the `connectedCallback` method in
   * a Stencil component.
   * @param contextKey - The context key.
   * @param initialValue - The value to be provided by the context.
   */
  provides(contextKey, initialValue) {
    if (!this.element.__provides) {
      return;
    }
    if (this.element.__provides.has(contextKey)) {
      console.warn(
        `Failed to provide "${contextKey}". The element already has a provider 
        with a context with the "${contextKey}" key registered. Use "update" method
        to change the context value.`
      );
      return;
    }
    this.element.__provides.set(contextKey, {
      currentValue: initialValue,
      callbacks: /* @__PURE__ */ new Set()
    });
  }
  /**
   * Updates the value of a context provided by the element to the child elements
   * that consume it.
   * @param contextKey - The context key to be updated.
   * @param value - The new value of the context to be defined.
   */
  update(contextKey, value) {
    if (!this.element.__provides) {
      return;
    }
    const currentProvider = this.element.__provides.get(contextKey);
    if (!currentProvider) {
      console.warn(
        `Error when using the "update" method to change the context value in 
        the Provider: "${contextKey}". Use the "provides" method to set 
        the context before updating.`
      );
      return;
    }
    if (!Object.is(value, currentProvider.currentValue)) {
      currentProvider.currentValue = value;
      currentProvider.callbacks?.forEach((callback) => {
        callback(value);
      });
    }
  }
  /**
   * Removes the contexts that were provided by the element for its child elements.
   */
  disconnect() {
    if (this.element.isConnected) {
      return;
    }
    this.element.removeAttribute("data-sy-provider");
    delete this.element.subscribe;
    delete this.element.unsubscribe;
    delete this.element.getCurrentValueOf;
    delete this.element.isProviderOf;
    delete this.element.__provides;
  }
};
var Consumer = class {
  /**
   * Creates an instance of a Consumer class.
   * @param element - The element this Consumer is associated with.
   */
  constructor(element) {
    this.element = element;
    this.providers = /* @__PURE__ */ new Map();
  }
  /**
   * Subscribes a new context to the Consumer to consume values provided by the Provider.
   * @param contextKey - The key to the context to be consumed.
   * @param callback - Callback function to update the value in the Consumer when the context changes.
   * @param options - Request options.
   * @returns - Returns the callback subscription.
   */
  subscribe(contextKey, callback, options) {
    const provider = getParentProvider(this.element, contextKey);
    if (!provider) {
      if (options?.suppress) {
        return;
      }
      console.warn(`No provider was found for the context key: ${contextKey}`);
      return;
    }
    this.providers.set(contextKey, [provider, callback]);
    return provider.subscribe?.(contextKey, callback);
  }
  /**
   * Gets the value provided by the Provider.
   * @param contextKey - The key to the context to be consumed.
   * @param options - Request options.
   * @returns - Returns the Provider value.
   */
  get(contextKey, options) {
    const provider = getParentProvider(this.element, contextKey);
    if (!provider) {
      if (options?.suppress) {
        return null;
      }
      console.warn(`No provider was found for the context key: ${contextKey}`);
      return null;
    }
    return provider.getCurrentValueOf?.(contextKey);
  }
  /**
   * @deprecated Use the `disconnect` method instead.
   * @param contextKey The context key to unsubscribe.
   */
  unsubscribe(contextKey) {
    const subscriptionInfo = this.providers.get(contextKey);
    if (subscriptionInfo) {
      const [provider, callback] = subscriptionInfo;
      provider.unsubscribe?.(contextKey, callback);
      this.providers.delete(contextKey);
    }
  }
  /**
   * Removes the contexts that were provided by the element for its child elements.
   */
  disconnect() {
    this.providers.forEach(([provider, callback], contextKey) => {
      provider.unsubscribe?.(contextKey, callback);
    });
    if (!this.element.isConnected) {
      this.providers.clear();
      return;
    }
    this.providers.forEach(([_, callback], contextKey) => {
      this.subscribe(contextKey, callback);
    });
  }
};
function getParentProvider(element, contextKey) {
  let currentElement = element;
  while (currentElement = getParentElement(currentElement)) {
    const closestProviderElement = closestShadow(currentElement, "[data-sy-provider]");
    if (!closestProviderElement) {
      return null;
    }
    if (closestProviderElement.isProviderOf?.(contextKey)) {
      return closestProviderElement;
    }
    currentElement = closestProviderElement;
  }
  return null;
}
function getParentElement(element) {
  if (element.assignedSlot) {
    element = element.assignedSlot;
  }
  if (!element.parentElement && element !== document.documentElement) {
    return element.getRootNode().host;
  }
  return element.parentElement;
}
function closestShadow(element, selector) {
  let currentElement = element;
  while (currentElement) {
    const closestElement = currentElement.closest(selector);
    if (closestElement) {
      return closestElement;
    }
    const rootNode = currentElement.getRootNode();
    const isLightDOM = rootNode === document.documentElement;
    if (isLightDOM) {
      return null;
    }
    currentElement = rootNode.host;
  }
  return null;
}

// src/lib/debounce-decorator.ts
var Debounce = (duration, keyFn) => {
  return (_target, key, descriptor) => {
    const originalMethod = descriptor.value;
    if (keyFn && keyFn.length > originalMethod.length) {
      console.error(`Debounce decorator keyFn argument list must match the decorated function (${key}). `);
    }
    descriptor.value = function(...args) {
      this.__debounce = this.__debounce ?? {};
      const debounceKey = keyFn ? `${key}.${keyFn(...args)}` : key;
      clearTimeout(this.__debounce[debounceKey]);
      this.__debounce[debounceKey] = setTimeout(() => {
        originalMethod.call(this, ...args);
      }, duration);
    };
  };
};

// src/lib/get-absolute-url.ts
function getAbsoluteUrl(url = "") {
  return new URL(url, document.baseURI).href;
}

// src/lib/get-action.ts
function getAction(routeIdentifier) {
  if (!routeIdentifier || !window?.sydleApp?.router?.actions) {
    return null;
  }
  return window.sydleApp.router.actions[routeIdentifier] ?? null;
}

// src/lib/get-config.ts
function getConfig(packageIdentifier) {
  if (!window.sydleApp?.config?.[packageIdentifier]) {
    return null;
  }
  return window.sydleApp?.config?.[packageIdentifier];
}

// src/lib/get-html-title.ts
function getHTMLTitle() {
  const titleElement = document.querySelector("title");
  return titleElement?.innerText;
}

// src/lib/get-route-by-id.ts
function getRouteById(id, routes) {
  routes = routes ?? getConfig("ui-app")?.routes;
  for (const route of routes || []) {
    if (route._id === id) {
      return route;
    }
    if (route.children) {
      const foundRoute = getRouteById(id, route.children);
      if (foundRoute) {
        return foundRoute;
      }
    }
  }
  return null;
}

// src/lib/get-route-by-identifier.ts
function getRouteByIdentifier(identifier, routes) {
  routes = routes ?? getConfig("ui-app")?.routes;
  for (const route of routes || []) {
    if (route.name === identifier) {
      return route;
    }
    if (route.children) {
      const foundRoute = getRouteByIdentifier(identifier, route.children);
      if (foundRoute) {
        return foundRoute;
      }
    }
  }
  return null;
}

// src/lib/get-router.ts
function getRouter() {
  if (!window.sydleApp?.router?.instance) {
    return null;
  }
  return window.sydleApp.router.instance;
}

// src/lib/navigate-to-path.ts
function navigateToPath(path) {
  window.history.pushState(null, document.title, path);
  return window.dispatchEvent(new PopStateEvent("popstate"));
}

// src/lib/url-for.ts
function urlFor(name, params, router = getRouter()) {
  let path;
  try {
    path = router?.urlForName(name, params) ?? "";
  } catch (error) {
    console.error(error);
    path = router?.urlForName("home") ?? "";
  }
  return path;
}

// src/lib/navigate.ts
function navigate(name, params, router = getRouter()) {
  const path = urlFor(name, params, router);
  return navigateToPath(path);
}

// src/lib/reload-page-content.ts
function reloadPageContent(element) {
  const reloadEvent = new CustomEvent("syAppCustomPageReloadElements", { bubbles: true });
  if (element) {
    return element.dispatchEvent(reloadEvent);
  }
  return document.body.dispatchEvent(reloadEvent);
}
function renderComponent(componentContent) {
  return h(componentContent.tag, componentContent.node, parseChildren(componentContent.children));
}
function parseChildren(children) {
  if (children.length < 1) {
    return [null];
  }
  return children.map((child) => {
    if (typeof child === "string") {
      return child;
    }
    return h(child.tag, child.node, parseChildren(child.children));
  });
}

// src/lib/set-action.ts
function setAction(routeIdentifier, actionFunction) {
  if (!window.sydleApp) {
    window.sydleApp = {};
  }
  if (!window.sydleApp?.router) {
    window.sydleApp.router = {};
  }
  if (!window.sydleApp.router.actions) {
    window.sydleApp.router.actions = {};
  }
  let previousAction;
  if (window.sydleApp.router.actions[routeIdentifier]) {
    previousAction = window.sydleApp.router.actions[routeIdentifier];
  }
  window.sydleApp.router.actions[routeIdentifier] = async (context, commands) => {
    const previousActionReturnValue = await previousAction?.(context, commands);
    if (previousActionReturnValue) {
      return previousActionReturnValue;
    }
    return actionFunction(context, commands);
  };
}

// src/lib/set-action-all.ts
function setActionAll(actionFunction, options) {
  let routes = getConfig("ui-app")?.routes;
  if (!routes || routes.length === 0) {
    return;
  }
  if (options?.baseRoute) {
    const baseRoute = getRouteByIdentifier(options.baseRoute);
    if (!baseRoute?.children || baseRoute.children.length === 0) {
      throw new Error("Base route has no subroutes.");
    }
    routes = baseRoute.children;
  }
  let routesToAddAction = routes;
  if (options?.includeSubroutesRecursively) {
    routesToAddAction = getRoutesWithoutChildren(routes);
  }
  routesToAddAction.forEach((route) => {
    const routeName = route.name;
    if (!routeName) {
      return;
    }
    if (options?.except?.includes(routeName)) {
      return;
    }
    setAction(routeName, actionFunction);
  });
}
function getRoutesWithoutChildren(routes) {
  let routesQueue = routes;
  const routesWithoutChildren = [];
  while (routesQueue.length !== 0) {
    const currentRoute = routesQueue.shift();
    if (currentRoute.children) {
      routesQueue = routesQueue.concat(currentRoute.children);
    } else {
      routesWithoutChildren.push(currentRoute);
    }
  }
  return routesWithoutChildren;
}

// src/lib/set-html-title.ts
function setHTMLTitle(title, sufix = "") {
  let titleElement = document.querySelector("title");
  if (!titleElement) {
    titleElement = document.createElement("title");
    document.head.appendChild(titleElement);
  }
  if (title || sufix) {
    const isFullTitle = title && sufix;
    titleElement.innerText = isFullTitle ? `${title} | ${sufix}` : title || sufix;
  }
}

// src/lib/throttle-decorator.ts
function Throttle(delay, keyFn) {
  return function(_target, key, descriptor) {
    const originalMethod = descriptor.value;
    if (keyFn && keyFn.length > originalMethod.length) {
      console.error(`Throttle decorator keyFn argument list must match the decorated function.`);
    }
    descriptor.value = function(...args) {
      this.__shouldWait = this.__shouldWait ?? {};
      this.__waitingArgs = this.__waitingArgs ?? {};
      const throttleKey = keyFn ? keyFn(...args) : key;
      const setTimeoutFn = () => {
        if (this.__waitingArgs?.[throttleKey]) {
          originalMethod.call(this, ...this.__waitingArgs[throttleKey]);
          this.__waitingArgs[throttleKey] = null;
          setTimeout(setTimeoutFn, delay);
        } else {
          if (!this.__shouldWait) {
            this.__shouldWait = {};
          }
          this.__shouldWait[throttleKey] = false;
        }
      };
      if (this.__shouldWait[throttleKey]) {
        this.__waitingArgs[throttleKey] = args;
        return;
      }
      this.__shouldWait[throttleKey] = true;
      originalMethod.call(this, ...args);
      setTimeout(setTimeoutFn, delay);
    };
  };
}

// src/index.ts
__reExport(src_exports, __toESM(require_sydle_app()));

// src/lib/url-utils.ts
function setURLParam(param, value, href = window.location.href) {
  const url = new URL(href);
  url.searchParams.set(param, value);
  window.history.replaceState(null, "", url.href);
  return url.href;
}
function getURLParam(param, href = window.location.href) {
  const url = new URL(href);
  return url.searchParams.get(param);
}
function getRelativeURL(href) {
  const currentLocation = window.location;
  const currentHref = currentLocation.href.endsWith("/") ? currentLocation.href : `${currentLocation.href}/`;
  const url = new URL(href, currentHref);
  return url.pathname;
}
function deleteURLParam(param, href = window.location.href) {
  const url = new URL(href);
  url.searchParams.delete(param);
  window.history.replaceState(null, "", url.href);
  return url.href;
}

export { Consumer, Debounce, Provider, Throttle, deleteURLParam, getAbsoluteUrl, getAction, getConfig, getHTMLTitle, getRelativeURL, getRouteById, getRouteByIdentifier, getRouter, getURLParam, navigate, navigateToPath, reloadPageContent, renderComponent, setAction, setActionAll, setHTMLTitle, setURLParam, urlFor };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map